/**
 * 商品 1 件の「答えられる問い」の数の短い表記。一覧の行で使う。
 *
 * **null は「数えていません」**で、0 件とは書かない（集計していない、
 * 集計の対象に入らなかった、のどちらでも同じ）。
 */

export function answerabilityText(
  answerability: { covered: number; decided: number } | null | undefined,
): string {
  if (answerability == null) return "数えていません";
  return `答えられる問い ${answerability.covered.toLocaleString("ja-JP")} / 判定 ${answerability.decided.toLocaleString("ja-JP")}`;
}
